const pageNameKey = "selectedTicketView";

export const selectedTicketViewEn = {
  [pageNameKey]: {
    noTicketsDetails: "No tickets details available.",
    subheaderText: "Conversation: Ticket #",
  },
};

export const selectedTicketViewPtBr = {
  [pageNameKey]: {
    noTicketsDetails: "Nenhum detalhe de ticket disponível.",
    subheaderText: "Conversa: Chamado nº",
  },
};

export const selectedTicketViewDe = {
  [pageNameKey]: {
    noTicketsDetails: "Keine Ticketdetails verfügbar.",
    subheaderText: "Konversation: Ticket #",
  },
};

export const selectedTicketViewZhHans = {
  [pageNameKey]: {
    noTicketsDetails: "没有可用的工单详情。",
    subheaderText: "对话：工单 #",
  },
};

export const selectedTicketViewIt = {
  [pageNameKey]: {
    noTicketsDetails: "Nessun dettaglio del ticket disponibile.",
    subheaderText: "Conversazione: Ticket #",
  },
};

export const selectedTicketViewEs = {
  [pageNameKey]: {
    noTicketsDetails: "No hay detalles de los tickets disponibles.",
    subheaderText: "Conversación: Ticket #",
  },
};

export const selectedTicketViewNl = {
  [pageNameKey]: {
    noTicketsDetails: "Geen ticketdetails beschikbaar.",
    subheaderText: "Gesprek: Ticket #",
  },
};

export const selectedTicketViewTr = {
  [pageNameKey]: {
    noTicketsDetails: "Bilet detayları mevcut değil.",
    subheaderText: "Konuşma: Bilet #",
  },
};
